import React, { FC } from 'react';
import { Resource, requestResourceByName, useScope } from 'ia-react-core';
import { AxiosResponse } from 'axios';
import { useDispatch } from 'react-redux';
import transformContestParticipation from './transformContestParticipation';
import getContestApiRoot from '../../../../utils/getContestApiRoot';
import { ContestInformation } from '../../../../interfaces/ContestInformation';
import { ResourceInfo } from '../../../Resource/Resource/Resource';
import { ContestResourceInfo } from '../ContestResource';

export const ContestParticipationResourceInfo: ResourceInfo = {
  name: '/App.contest.participationResource',
  dataDst: '/App.contest.participation',
};
export interface ContestParticipationResourceProps { }

const ContestParticipationResource: FC<ContestParticipationResourceProps> = () => {
  const dispatch = useDispatch();
  const { getScopedState } = useScope();
  const contest: ContestInformation = getScopedState(ContestResourceInfo.dataDst);
  if (!contest) return null;

  return (
    <Resource
      autoRequest
      {...ContestParticipationResourceInfo}
      url={`${getContestApiRoot()}/${contest.promoterCode}/participants/self`}
      transformResponse={(response: AxiosResponse) => transformContestParticipation(response?.data)}
      onFailure={(x) => {
        const response = (x as { response: AxiosResponse })?.response;
        if (response?.status === 404 && contest?.isActive) {
          dispatch(requestResourceByName('/App.contest.subscribeResource'));
        }
      }}
    />
  );
};

export default ContestParticipationResource;
